module.exports = __webpack_public_path__ + "img/p2.c6665054.png";